import {
  type PackageDomainSelectModel,
  PackageFormats,
  PackageId,
  PackageSources,
  PackageUrn,
} from '@mntn-dev/domain-types'
import { calculateCostPlusMargin } from '@mntn-dev/finance-utilities'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockPackage = MockModel<PackageDomainSelectModel>(
  ({
    packageId = PackageId(),
    packageUrn = PackageUrn(packageId),
    name = `Name ${packageId}`,
    description = `Description ${packageId}`,
    packageSource = getRandomItem(PackageSources),
    packageFormat = getRandomItem(PackageFormats),
    cost = 1,
    costMarginPercent = 50,
    costPlusMargin = calculateCostPlusMargin(cost, costMarginPercent),
    status = 'draft',
    visibility = 'external',
  }) => {
    return {
      packageId,
      packageUrn,
      name,
      description,
      packageSource,
      packageFormat,
      cost,
      costMarginPercent,
      costPlusMargin,
      status,
      visibility,
    } satisfies PackageDomainSelectModel
  }
)
